import { ReckittApplicationParameters } from '@platform/client/schemas';
import { FormsInputDropdown, InlineFormInput } from '@platform/components';
import { SubmitHandler, useForm } from 'react-hook-form';
import { ApplicationPageProps } from '../../Application';
import { useApplicationLocalStorage } from '../../application-hook';
import { ApplicationBackground } from '../../ApplicationBackground';
import { ApplicationPageContent } from '../../components/ApplicationPageContent';
import BackgroundImage from '../../images/Screen4Reckitt.svg';

type FormValues = {
  jobFunction: string;
  businessUnit: string;
};

const RECKITT_BUSINESS_UNIT_OPTIONS = [
  { text: 'Health', textValue: 'Health' },
  { text: 'Hygiene', textValue: 'Hygiene' },
  { text: 'Nutrition', textValue: 'Nutrition' },
  { text: 'eRB/Greater China', textValue: 'eRB/Greater China' },
  { text: 'Corporate', textValue: 'Corporate' },
];

export const ReckittWorkExperience = (props: ApplicationPageProps) => {
  const { onBack, onContinue, progress } = { ...props };

  const { updateApplicationData, getApplicationDataByKey } =
    useApplicationLocalStorage<ReckittApplicationParameters>();

  const {
    register,
    handleSubmit,
    watch,
    formState: { errors },
    control,
  } = useForm<FormValues>({
    mode: 'onBlur',
    reValidateMode: 'onChange',
    defaultValues: {
      jobFunction: getApplicationDataByKey('jobFunction'),
      businessUnit: getApplicationDataByKey('businessUnit'),
    },
  });

  const submit: SubmitHandler<FormValues> = (data) => {
    updateApplicationData({ jobFunction: data.jobFunction, businessUnit: data.businessUnit });
    onContinue();
  };

  const handleBack = () => {
    updateApplicationData({
      jobFunction: watch('jobFunction'),
      businessUnit: watch('businessUnit'),
    });
    onBack();
  };

  return (
    <ApplicationBackground
      progress={progress}
      onBack={handleBack}
      onSubmit={handleSubmit(submit)}
      backgroundImage={BackgroundImage}
    >
      <ApplicationPageContent
        title='Tell us about your work at Reckitt'
        description="Your company wants to know these details as part of your application, but they won't appear as part of your profile."
      >
        <InlineFormInput
          label='Job function'
          placeholder='Enter your job function at Reckitt'
          register={() => {
            return register('jobFunction', {
              required: 'Select your job function to continue',
            });
          }}
          errors={errors.jobFunction}
        />
        <FormsInputDropdown
          control={control}
          name='businessUnit'
          rules={{ required: 'Select your business unit to continue' }}
          label='What is your business unit?'
          placeholder='Select one'
          items={RECKITT_BUSINESS_UNIT_OPTIONS}
          type='default'
          error={errors.businessUnit}
        />
      </ApplicationPageContent>
    </ApplicationBackground>
  );
};
